import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { IdpresponseComponent } from './idpresponse/idpresponse.component';

const routes: Routes = [
  {
    path: '',
    children: [
      {
        path: '',
        redirectTo: 'idpresponse',
        pathMatch: 'full'
      },
      {
        path: 'idpresponse',
        component: IdpresponseComponent
      }
    ]
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class Oauth2RoutingModule { }
